import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Companion_instance2qx5twdgt0if1 as Companion_instance,
  IntProgressionfaq59u1bhfih as IntProgression,
  Companion_instancengy76erk0rf3 as Companion_instance_0,
  LongProgression4dpjnpwadpbx as LongProgression,
} from './Progressions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  ClosedRangehokgr73im9z3 as ClosedRange,
  OpenEndRange1a2my95ycmxk8 as OpenEndRange,
} from './Range.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        this.EMPTY_1 = new (IntRange())(1, 0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 === VOID) {
    Companion_instance;
    new (Companion())();
  }
  return Companion_instance_1;
}
var IntRangeClass;
function IntRange() {
  if (IntRangeClass === VOID) {
    class $ extends IntProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance();
        super(start, endInclusive, 1);
      }
      get_start_iypx6h_k$() {
        return this.first_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.last_1;
      }
      get_endExclusive_pmwm6k_k$() {
        if (this.last_1 === 2147483647) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes MAX_VALUE.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        return this.last_1 + 1 | 0;
      }
      contains_7q95ev_k$(value) {
        return this.first_1 <= value && value <= this.last_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_7q95ev_k$(typeof value === 'number' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return this.first_1 > this.last_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof IntRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, this.first_1) + this.last_1 | 0;
      }
      toString() {
        return '' + this.first_1 + '..' + this.last_1;
      }
    }
    initMetadataForClass($, 'IntRange', VOID, VOID, [ClosedRange(), OpenEndRange()]);
    IntRangeClass = $;
  }
  return IntRangeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        this.EMPTY_1 = new (LongRange())(1n, 0n);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_2;
function Companion_getInstance_0() {
  if (Companion_instance_2 === VOID) {
    Companion_instance_0;
    new (Companion_0())();
  }
  return Companion_instance_2;
}
var LongRangeClass;
function LongRange() {
  if (LongRangeClass === VOID) {
    class $ extends LongProgression() {
      constructor(start, endInclusive) {
        Companion_getInstance_0();
        super(start, endInclusive, 1n);
      }
      get_start_iypx6h_k$() {
        return this.first_1;
      }
      get_endInclusive_r07xpi_k$() {
        return this.last_1;
      }
      get_endExclusive_pmwm6k_k$() {
        if (this.last_1 === 9223372036854775807n) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot return the exclusive upper bound of a range that includes MAX_VALUE.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.last_1;
        return add(this_0, fromInt(1));
      }
      contains_f9h079_k$(value) {
        return this.first_1 <= value && value <= this.last_1;
      }
      contains_3tkdvy_k$(value) {
        return this.contains_f9h079_k$(typeof value === 'bigint' ? value : THROW_CCE());
      }
      isEmpty_y1axqb_k$() {
        return this.first_1 > this.last_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof LongRange()) {
          tmp = this.isEmpty_y1axqb_k$() && other.isEmpty_y1axqb_k$() || (this.first_1 === other.first_1 && this.last_1 === other.last_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.isEmpty_y1axqb_k$() ? -1 : imul(31, getBigIntHashCode(this.first_1)) + getBigIntHashCode(this.last_1) | 0;
      }
      toString() {
        return this.first_1.toString() + '..' + this.last_1.toString();
      }
    }
    initMetadataForClass($, 'LongRange', VOID, VOID, [ClosedRange(), OpenEndRange()]);
    LongRangeClass = $;
  }
  return LongRangeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceswkziix95xfy,
  IntRange as IntRange1cx8zvxgibbj2,
  LongRange as LongRange138sb2ngfio7d,
};
//endregion

//# sourceMappingURL=PrimitiveRanges.mjs.map
